<template>
  <Loading v-if="componentLoading" :style="style" />
  <Chart v-else-if="visible" class="pie-doughnut-chart" :option="pieChartConfig" :deepUpdate="true" :style="style"></Chart>
</template>

<script setup lang="ts">
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import { ref, nextTick } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import defaultOption from "./chart-config"
import useToggle from "@p-v/hooks/useToggle"
import Loading from "@p-v/packages/Loading.vue"
import { EChartsOption, PieSeriesOption } from "echarts"

export interface PieDoughuntChartProps {
  data?: PieSeriesOption["data"] // 两条线的数据
  config?: EChartsOption // 配置项
  style?: { [key: string]: string } // 配置项
  show?: boolean
}

const componentLoading = ref<boolean>(true)

// 引入默认模板配置
const pieChartConfig = ref<EChartsOption>(cloneDeep(defaultOption))

// 定义props
const props = withDefaults(defineProps<PieDoughuntChartProps>(), {
  data: () => [],
  config: () => ({}),
  style: () => ({}),
  show: () => true,
})

const { visible, show, hide, changeVisible } = useToggle(props.show)

function componentPropEngine(propsData: PieDoughuntChartProps): EChartsOption {
  const { data, config: _config } = propsData
  const newConfig = cloneDeep(defaultOption)
  const configFromProp = cloneDeep(_config)
  const configResult = defaultsDeep(configFromProp, props.config, newConfig)

  if (data && data.length > 0) {
    configResult.series[0].data = data
    // 移除暂无数据的文本
    // delete configResult.graphic;
    configResult.graphic[0].invisible = true
  } else {
    configResult.series = []
  }

  return configResult
}

const loading = () => {
  componentLoading.value = true
}
const setData = (
  data:
    | PieSeriesOption["data"]
    | {
        data: PieSeriesOption["data"]
        config?: EChartsOption
      },
  option?: EChartsOption,
) => {
  if (!data) {
    return
  }
  // console.log(data)
  if (!Array.isArray(data)) {
    const result = componentPropEngine(data)
    // console.log("result", result)
    componentLoading.value = false
    nextTick(() => {
      pieChartConfig.value = result
    })
    return
  } else {
    const result = componentPropEngine({ data, config: option })
    componentLoading.value = false
    nextTick(() => {
      pieChartConfig.value = result
    })
  }
}
defineExpose({ setData, loading, show, hide, changeVisible })
</script>

<style lang="scss" scoped></style>
